import { forwardRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import styled from 'styled-components';
import 'ag-grid-community/styles//ag-grid.css';
import 'ag-grid-community/styles//ag-theme-alpine.css';
import '../styles/tableFonts/agTableFonts.css';
import { BlackBorderButtonWithWriteAccess as EditButton } from './Button';
import { defaultRowHeight } from 'utils/appConstants';

const TitleContainer = styled.div`
  display: flex;
  margin-bottom: 7px;
`;

// Default column definitions that affect every table instance
export const defaultColumnDefinitions = {
  resizable: true,
  sortable: true,
  filter: true,
  flex: 1
};

const headerStyles = `
  flex: 1;
`;

const StyledH3 = styled.h3`
  ${headerStyles}
`;
const StyledH4 = styled.h4`
  ${headerStyles}
`;

// Row height is determined via a callback
const defaultGetRowHeight = () => defaultRowHeight;

// Use forwardRef to pass along the ref from the parent component
// into this instance of Table.
// Ref must come from the parent in the form of prop of `ref={refTitleHere}`.
// `forwardRef` takes two parameters, props (destructured here), and the ref
const Table = forwardRef(
  (
    {
      columnDefs,
      rowData,
      onRowClicked,
      showEditButton,
      handleEdit,
      paginationPageSize = 20,
      bigTitle,
      smallTitle,
      width = '100%',
      height = '400px',
      getRowHeight = defaultGetRowHeight,
      defaultColDef = defaultColumnDefinitions,
      pagination = true,
      margin = '0px 8px',
      padding = '16px 16px 40px',
      className
    },
    ref
  ) => {
    return (
      <div
        className={`ag-theme-alpine ag-grid-react ag-font-alpha ${
          className ? className : ''
        }`}
        style={{
          borderRadius: '4px',
          backgroundColor: '#ffffff',
          width,
          height,
          margin,
          padding,
          color: 'black',
          fontFamily: 'Crossten',
          marginTop: '20px',
          boxSizing: 'content-box'
        }}
      >
        <TitleContainer>
          {bigTitle && <StyledH3>{bigTitle}</StyledH3>}
          {smallTitle && <StyledH4>{smallTitle}</StyledH4>}
          {showEditButton && <EditButton onClick={handleEdit}>Edit</EditButton>}
        </TitleContainer>
        <AgGridReact
          onRowClicked={onRowClicked}
          ref={ref}
          columnDefs={columnDefs}
          rowData={rowData}
          defaultColDef={defaultColDef}
          animateRows={true}
          pagination={pagination}
          paginationPageSize={paginationPageSize}
          getRowHeight={getRowHeight}
        />
      </div>
    );
  }
);

export default Table;
